// reducer.js
const SET_ROLES_PERMISSIONS = 'SET_ROLES_PERMISSIONS'
const initialState = {
  role: '',
  permissions: [],
};

const roleReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ROLES_PERMISSIONS:
      return {
        ...state,
        role: action.payload.roles,
        permissions: action.payload.permissions,
      };
    default:
      return state;
  }
};

export default roleReducer;
